import { render, staticRenderFns } from "./populationBaseInfo.vue?vue&type=template&id=56faee36&scoped=true"
import script from "./populationBaseInfo.vue?vue&type=script&lang=js"
export * from "./populationBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./populationBaseInfo.vue?vue&type=style&index=0&id=56faee36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56faee36",
  null
  
)

export default component.exports